<ion-card class="action-card skinny-card">
  <ion-list class="no-padding transparent-bg">
    <ion-item class="box-header-item">
      <ion-badge
        [color]="step.type === 'branches' ? 'secondary' : 'tertiary'"
        slot="start"
        style="margin-right: 12px; font-size: 1.2rem"
      >
        <ion-icon
          [name]="
            step.type === 'branches'
              ? 'git-branch-outline'
              : AUTOMATION_ACTION_TYPES_ICONS[step.data.action.type]
          "
        ></ion-icon>
      </ion-badge>
      <ion-label>
        <p style="margin: 0; font-size: 0.7rem">Step {{ index + 1 }}</p>
        <h3 style="margin: 0 0 4px 0; font-weight: 500">
          {{
            step.type === "branches"
              ? "Branch"
              : AUTOMATION_ACTION_TYPES_LABELS[step.data.action.type]
          }}
        </h3>
      </ion-label>
      <ion-icon
        *ngIf="canDrag"
        name="reorder-two-outline"
        slot="end"
        style="cursor: grab"
      ></ion-icon>
      <ion-button
        slot="end"
        fill="clear"
        color="dark"
        (click)="handleOptionsClick()"
        class="item-accessory-button"
      >
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </ion-button>
    </ion-item>
  </ion-list>

  <ng-container *ngIf="step.type === 'action'">
    <ng-container [ngSwitch]="step.data.action.type">
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.CREATE_APPROVAL_REQUEST"
      >
        <ion-label class="input-label">Send to user or team</ion-label>
        <br />
        <ion-chip
          mode="ios"
          class="select-chip select-outline no-margin"
          [outline]="true"
          (click)="selectAssignee(step.data.action.data)"
        >
          <ion-label>
            {{
              lookups?.["assigneeId"]?.[step.data.action.data.entityId] ??
                lookups?.["groupId"]?.[step.data.action.data.entityId] ??
                lookups?.["userGroupId"]?.[step.data.action.data.entityId] ??
                "No one"
            }}
            <ion-icon
              name="caret-down-outline"
              class="icon-padded-left"
            ></ion-icon>
          </ion-label>
        </ion-chip>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.ASSIGN_CONVERSATION"
      >
        <div>
          <ion-label class="input-label">Assign to user or team</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectResolvableEntity(step.data.action.data, 'entityId')"
          >
            <ion-label>
              {{
                step.data.action.data.entityId
                  ? getResolvableEntityLabel(step.data.action.data.entityId)
                  : "Select user or user group field"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <!-- Specific User Selection (Conditional) -->
        <div
          style="margin-top: 10px"
          *ngIf="isEmptyEntityType(step.data.action.data.entityId)"
        >
          <ion-label class="input-label"
            >Select Specific User or User Group</ion-label
          >
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectAssignee(step.data.action.data)"
          >
            <ion-label>
              {{
                lookups?.["assigneeId"]?.[
                  step.data.action.data.entityId ?? ""
                ] ??
                  lookups?.["groupId"]?.[
                    step.data.action.data.entityId ?? ""
                  ] ??
                  lookups?.["userGroupId"]?.[
                    step.data.action.data.entityId ?? ""
                  ] ??
                  "Select user or user group"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.ADD_CONVERSATION_FOLLOWER"
      >
        <ion-label class="input-label">Add user or team</ion-label>
        <br />

        <ion-chip
          mode="ios"
          class="select-chip select-outline no-margin"
          [outline]="true"
          (click)="selectAssignee(step.data.action.data)"
        >
          <ion-label>
            {{
              lookups?.["assigneeId"]?.[step.data.action.data.entityId] ??
                lookups?.["groupId"]?.[step.data.action.data.entityId] ??
                lookups?.["userGroupId"]?.[step.data.action.data.entityId] ??
                "No one"
            }}
            <ion-icon
              name="caret-down-outline"
              class="icon-padded-left"
            ></ion-icon>
          </ion-label>
        </ion-chip>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.SET_CONVERSATION_COLLABORATOR"
      >
        <div>
          <ion-label class="input-label">Set collaborator type</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectCollaboratorType(step.data.action.data)"
          >
            <ion-label>
              {{
                lookups?.["collaboratorTypeId"]?.[
                  step.data.action.data.collaboratorTypeId
                ] ?? "Select collaborator type"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <div style="margin-top: 10px">
          <ion-label class="input-label">Collaborator to Add</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectResolvableEntity(step.data.action.data, 'entityId')"
          >
            <ion-label>
              {{
                step.data.action.data.entityId
                  ? getResolvableEntityLabel(step.data.action.data.entityId)
                  : "Select user or user group field"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <!-- Specific User Selection (Conditional) -->
        <div
          style="margin-top: 10px"
          *ngIf="isEmptyEntityType(step.data.action.data.entityId)"
        >
          <ion-label class="input-label"
            >Select Specific User or User Group</ion-label
          >
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectSpecificEntity(step.data.action.data, 'entityId')"
          >
            <ion-label>
              {{
                lookups?.["assigneeId"]?.[
                  step.data.action.data.entityId?.value ?? ""
                ] ??
                  lookups?.["groupId"]?.[
                    step.data.action.data.entityId?.value ?? ""
                  ] ??
                  lookups?.["userGroupId"]?.[
                    step.data.action.data.entityId?.value ?? ""
                  ] ??
                  "Select user or user group"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.SET_CONVERSATION_PRIORITY"
      >
        <div class="flexed">
          <div
            *ngFor="
              let option of priorityOptionsForTemplate;
              let first = first;
              let last = last
            "
            class="round-pill-tab"
            [ngClass]="{
              'round-pill-tab-left': first,
              'round-pill-tab-right': last,
              'round-pill-tab-active':
                step.data.action.data.priority === option.value
            }"
            (click)="step.data.action.data.priority = option.value"
          >
            {{ option.label }}
          </div>
        </div>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.CHANGE_CONVERSATION_STATUS"
      >
        <div class="flexed">
          <div
            class="round-pill-tab round-pill-tab-left"
            [ngClass]="{
              'round-pill-tab-active': step.data.action.data.status === 'open'
            }"
            (click)="step.data.action.data.status = 'open'"
          >
            <ion-icon
              name="custom-open"
              class="status-label-needs-response"
            ></ion-icon>
            Needs response
          </div>
          <div
            class="round-pill-tab"
            [ngClass]="{
              'round-pill-tab-active':
                step.data.action.data.status === 'in_progress'
            }"
            (click)="step.data.action.data.status = 'in_progress'"
          >
            <ion-icon
              name="custom-in-progress"
              class="status-label-in-progress"
            ></ion-icon>
            In progress
          </div>
          <div
            class="round-pill-tab"
            [ngClass]="{
              'round-pill-tab-active':
                step.data.action.data.status === 'on_hold'
            }"
            (click)="step.data.action.data.status = 'on_hold'"
          >
            <ion-icon
              name="custom-on-hold"
              class="status-label-on-hold"
            ></ion-icon>
            On hold
          </div>
          <div
            class="round-pill-tab round-pill-tab-right"
            [ngClass]="{
              'round-pill-tab-active': step.data.action.data.status === 'closed'
            }"
            (click)="step.data.action.data.status = 'closed'"
          >
            <ion-icon
              name="custom-closed"
              class="status-label-closed"
            ></ion-icon>
            Closed
          </div>
        </div>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.CHANGE_CONVERSATION_SUB_STATUS"
      >
        <div class="flexed">
          <div>
            <ion-label class="input-label">Status</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              (click)="selectSubStatus(step.data.action.data)"
            >
              <ion-icon
                *ngIf="getSubStatusIcon(step.data.action.data.subStatusKey)"
                [name]="getSubStatusIcon(step.data.action.data.subStatusKey)"
                [class]="
                  getSubStatusIconClass(step.data.action.data.subStatusKey)
                "
                style="margin-right: 5px; width: 12.8px; height: 12.8px"
              ></ion-icon>
              <ion-label>
                {{
                  lookups?.["subStatusKey"]?.[
                    step.data.action.data.subStatusKey
                  ] ?? "Select status"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
        </div>
      </ion-card-content>

      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.WAIT">
        <ion-label class="input-label">Delay (in minutes)</ion-label>
        <div class="flexed-align-center">
          <ion-input
            *ngIf="step.data.action.data.wait"
            class="input-field"
            placeholder="Enter minutes"
            [(ngModel)]="step.data.action.data.wait.minutes"
            type="number"
            min="1"
            step="1"
          ></ion-input>
          <ion-toggle
            (ionChange)="toggleWorkingTimeOnly(step.data.action.data)"
            [checked]="step.data.action.data.wait.workingTimeOnly"
          ></ion-toggle>
          <ion-label class="input-label">Working time only</ion-label>
        </div>

        <!-- Advanced Settings Section -->
        <div
          *ngIf="triggerType === 'event'"
          style="
            margin-top: 15px;
            padding-top: 10px;
            border-top: 1px solid var(--ion-border-color);
          "
        >
          <ion-button
            color="dark"
            fill="clear"
            class="btn-small"
            (click)="toggleAdvancedSettings()"
          >
            <ion-icon
              [name]="
                showAdvancedSettings
                  ? 'chevron-down-outline'
                  : 'chevron-forward-outline'
              "
              class="padded-icon"
            ></ion-icon>
            Advanced Settings
          </ion-button>
        </div>

        <div *ngIf="showAdvancedSettings" style="margin-top: 10px">
          <ion-label class="input-label"
            >Abort wait when these events occur:</ion-label
          >
          <div style="margin-top: 8px; display: flex; flex-wrap: wrap">
            <ion-chip
              mode="ios"
              class="select-chip select-outline"
              style="margin: 0 5px 5px 0"
              [outline]="true"
              *ngFor="
                let abortEvent of step.data.action.data.wait.abortOn || [];
                let i = index
              "
              (click)="removeAbortEvent(step.data.action.data.wait, i)"
            >
              <ion-label>
                <ion-icon name="close-circle"></ion-icon>
                {{ formatAbortEventLabel(abortEvent) }}
              </ion-label>
            </ion-chip>
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              (click)="selectAbortEvent(step.data.action.data.wait)"
            >
              <ion-label>
                <ion-icon name="add-outline"></ion-icon>
                Add event
              </ion-label>
            </ion-chip>
          </div>
          <ion-note class="input-label" style="display: block; margin-top: 8px">
            If any of these events occur during the wait period, the automation
            will stop immediately.
          </ion-note>
        </div>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.SEND_SLACK_TEMPLATE"
      >
        <div
          [hidden]="step.data.action.data.templateId"
          style="border-radius: 8px; border: 1px solid var(--ion-border-color)"
        >
          <app-slack-text-editor
            [content]="step.data.action.data.body?.value"
            [isRichText]="false"
            placeholder="Enter message"
            (contentDidChange)="step.data.action.data.body.value = $event"
            [projectId]="projectId ?? undefined"
            [enableSlackMentions]="true"
            [teamId]="getSlackTeamIdForStep(step)"
          ></app-slack-text-editor>
        </div>
        <div *ngIf="step.data.action.data.templateId">
          <ion-spinner
            *ngIf="
              !lookups?.['templateHtml']?.[step.data.action.data.templateId]
            "
            name="dots"
            style="margin-top: 10px; margin-bottom: 10px"
          ></ion-spinner>
          <app-slack-message
            *ngIf="
              lookups?.['templateHtml']?.[step.data.action.data.templateId]
            "
            [content]="
              lookups?.['templateHtml']?.[step.data.action.data.templateId]
            "
          ></app-slack-message>
        </div>
        <div
          class="flexed"
          style="
            margin-top: 15px;
            padding-top: 10px;
            border-top: 1px solid var(--ion-border-color);
          "
        >
          <div>
            <ion-label class="input-label">Use a template</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline"
              [outline]="true"
              (click)="selectTemplate(step.data.action.data)"
              style="width: 100%; margin-left: -1px"
            >
              <ion-label>
                {{
                  lookups?.["templateId"]?.[step.data.action.data.templateId] ??
                    "Select template"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <div style="width: 50%; margin-left: 8px">
            <ion-label class="input-label">Send as</ion-label>
            <br />
            <ion-select
              mode="ios"
              class="input-field select-outline"
              interface="popover"
              placeholder="Select user"
              aria-label="Send as"
              [(ngModel)]="step.data.action.data.sendAs"
              value="support_team"
              style="
                padding-right: 13px;
                padding-top: 6px;
                padding-bottom: 6px;
                padding-left: 1px;
                font-size: 0.75rem;
                margin-top: 4px;
                padding-left: 11px;
              "
            >
              <ion-select-option value="support_team"
                >Support Team (default)</ion-select-option
              >
              <ion-select-option value="ticket_assignee"
                >Ticket Assignee</ion-select-option
              >
            </ion-select>
          </div>
        </div>

        <div style="margin-top: 10px">
          <ion-label class="input-label">Post message to </ion-label>

          <div class="pill-tab-container">
            <div
              class="round-pill-tab"
              [ngClass]="{
                'round-pill-tab-active':
                  getPostingTarget(step.data.action.data) === 'main_thread'
              }"
              (click)="setPostingTarget(step.data.action.data, 'main_thread')"
            >
              Main thread
            </div>
            <div
              class="round-pill-tab"
              [ngClass]="{
                'round-pill-tab-active':
                  getPostingTarget(step.data.action.data) === 'direct_message'
              }"
              (click)="
                setPostingTarget(step.data.action.data, 'direct_message')
              "
            >
              Direct message
            </div>
            <div
              class="round-pill-tab"
              [ngClass]="{
                'round-pill-tab-active':
                  getPostingTarget(step.data.action.data) === 'triage_thread'
              }"
              (click)="setPostingTarget(step.data.action.data, 'triage_thread')"
            >
              Triage thread
            </div>
          </div>
        </div>

        <div
          style="margin-top: 10px"
          *ngIf="getPostingTarget(step.data.action.data) === 'direct_message'"
        >
          <ion-label class="input-label">Send a DM to</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectResolvableEntity(step.data.action.data, 'entityId')"
          >
            <ion-label>
              {{
                step.data.action.data.entityId
                  ? getResolvableEntityLabel(step.data.action.data.entityId)
                  : "Select user or user group field"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <!-- Specific User Selection (Conditional) -->
        <div
          style="margin-top: 10px"
          *ngIf="isEmptyEntityType(step.data.action.data.entityId)"
        >
          <ion-label class="input-label"
            >Select specific user or user group</ion-label
          >
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectAssignee(step.data.action.data)"
          >
            <ion-label>
              {{
                lookups?.["assigneeId"]?.[
                  step.data.action.data.entityId?.value ?? ""
                ] ??
                  lookups?.["groupId"]?.[
                    step.data.action.data.entityId?.value ?? ""
                  ] ??
                  lookups?.["userGroupId"]?.[
                    step.data.action.data.entityId?.value ?? ""
                  ] ??
                  "Select user or user group"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <!-- Advanced Settings Section -->
        <div
          style="
            margin-top: 15px;
            padding-top: 10px;
            border-top: 1px solid var(--ion-border-color);
          "
        >
          <ion-button
            color="dark"
            fill="clear"
            class="btn-small"
            (click)="toggleAdvancedSettings()"
          >
            <ion-icon
              [name]="
                showAdvancedSettings
                  ? 'chevron-down-outline'
                  : 'chevron-forward-outline'
              "
              class="padded-icon"
            ></ion-icon>
            Advanced Settings
          </ion-button>
        </div>

        <div *ngIf="showAdvancedSettings" style="margin-top: 10px">
          <div class="flexed-align-center">
            <ion-toggle
              [(ngModel)]="step.data.action.data.isAutoresponse"
              [checked]="step.data.action.data.isAutoresponse !== false"
            ></ion-toggle>
            <ion-label class="input-label">Treat as autoresponse</ion-label>
          </div>
          <ion-note class="input-label" style="display: block; margin-top: 8px">
            When enabled, this message will be marked as an automated response.
            Disable if you want the message to appear as a regular team message.
          </ion-note>
        </div>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.ADD_CONVERSATION_TAGS"
      >
        <ion-chip
          mode="ios"
          class="select-chip select-outline"
          style="margin: 0 5px 0 0"
          [outline]="true"
          *ngFor="
            let tagId of step.data.action.data.tagIds || [];
            let i = index
          "
          (click)="removeTag(step.data.action.data, i)"
        >
          <ion-label>
            <ion-icon name="pricetag"></ion-icon>
            {{ lookups?.["tagId"]?.[tagId] ?? tagId }}
          </ion-label>
        </ion-chip>
        <ion-chip
          mode="ios"
          class="select-chip select-outline no-margin"
          [outline]="true"
          (click)="selectTag(step.data.action.data)"
        >
          <ion-label>
            <ion-icon name="add-outline"></ion-icon>
            Choose tag
          </ion-label>
        </ion-chip>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.TRIGGER_FUNCTION"
      >
        <ion-label class="input-label" *ngIf="functionNames?.length"
          >Function name</ion-label
        >
        <ion-select
          *ngIf="functionNames?.length"
          placeholder="Select function"
          class="input-field"
          interface="popover"
          [(ngModel)]="step.data.action.data.functionName"
          [compareWith]="compareFn"
        >
          <ion-select-option *ngFor="let name of functionNames" [value]="name">
            {{ name }}
          </ion-select-option>
        </ion-select>
        <ion-button
          color="dark"
          (click)="editFunctions()"
          class="btn-small"
          style="margin-top: 14px"
        >
          <ion-icon name="code-outline" class="padded-icon"></ion-icon>
          {{
            functionNames?.length
              ? "Edit Functions"
              : "Create your first function"
          }}
        </ion-button>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.SET_CONVERSATION_TICKET_TYPE"
      >
        <ion-label class="input-label">Assign ticket type</ion-label>
        <br />

        <ion-chip
          mode="ios"
          class="select-chip select-outline no-margin"
          [outline]="true"
          (click)="selectTicketType(step.data.action.data)"
        >
          <ion-label>
            {{
              lookups?.["ticketTypeId"]?.[step.data.action.data.ticketTypeId] ??
                "None"
            }}
            <ion-icon
              name="caret-down-outline"
              class="icon-padded-left"
            ></ion-icon>
          </ion-label>
        </ion-chip>
      </ion-card-content>
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.SET_SLACK_USER_GROUP_MEMBERSHIP"
      >
        <div>
          <ion-label class="input-label">Slack User Group to Modify</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            (click)="selectSlackUserGroup(step.data.action.data)"
            style="margin-left: 0"
          >
            <ion-label>
              {{
                lookups?.["slackGroupId"]?.[
                  step.data.action.data.slackUserGroupId
                ] ?? "Select user group"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <div>
          <ion-label class="input-label">Users to Add</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            style="margin: 0 5px 0 0"
            *ngFor="let userId of step.data.action.data.userIds; let i = index"
            (click)="removeUserFromList(step.data.action.data, i)"
          >
            <ion-label>
              {{ lookups?.["assigneeId"]?.[userId] ?? userId }}
              <ion-icon
                name="close-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectUserForList(step.data.action.data)"
          >
            <ion-label>
              <ion-icon name="add-outline"></ion-icon>
              Choose users
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.POST_TO_TRIAGE">
        <div>
          <ion-label class="input-label">Triage channel</ion-label>
          <br />

          <div class="flexed-align-center">
            <app-channel-selector
              [channel]="
                step.data.action.data.channelId
                  ? {
                      id: step.data.action.data.channelId,
                      name:
                        lookups?.['slackChannelId']?.[
                          step.data.action.data.channelId
                        ] ?? step.data.action.data.channelId
                    }
                  : undefined
              "
              (channelDidChange)="onSlackChannelChange($event)"
              [defaultInternalOnly]="true"
              [disabled]="step.data.action.data.createChannel"
              [hideUnlinkButton]="true"
              [hideLinkedToText]="true"
            ></app-channel-selector>

            <ion-button
              color="dark"
              fill="clear"
              class="btn-small"
              (click)="
                toggleCreateTemporaryTriageChannel(step.data.action.data)
              "
            >
              <ion-icon
                [name]="
                  step.data.action.data.createChannel
                    ? 'checkbox'
                    : 'square-outline'
                "
                class="padded-icon"
              ></ion-icon>
              Create temporary channel
            </ion-button>
          </div>
        </div>

        <div
          style="margin-top: 10px"
          *ngIf="step.data.action.data.createChannel"
        >
          <ion-label class="input-label"
            >Channel name prefix (optional)</ion-label
          >
          <br />
          <ion-input
            class="input-field"
            placeholder="Example: 'incident-'"
            [(ngModel)]="step.data.action.data.createChannel.prefix"
          >
          </ion-input>
          <ion-note class="input-label">
            Conversation ID will be appended to the prefix entered above.
          </ion-note>
          <div class="flexed-align-center">
            <ion-toggle
              [(ngModel)]="step.data.action.data.createChannel.isPrivate"
            ></ion-toggle>
            <ion-label class="input-label">Private channel</ion-label>
          </div>
        </div>

        <div style="margin-top: 10px">
          <ion-label class="input-label">Tag a user or team</ion-label>
          <br />

          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectAssignee(step.data.action.data.tag)"
          >
            <ion-label>
              {{
                lookups?.["assigneeId"]?.[step.data.action.data.tag.entityId] ??
                  lookups?.["groupId"]?.[step.data.action.data.tag.entityId] ??
                  lookups?.["userGroupId"]?.[
                    step.data.action.data.tag.entityId
                  ] ??
                  "No one"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <div style="margin-top: 10px">
          <ion-label class="input-label">Custom note</ion-label>
          <br />
          <ion-input
            class="input-field"
            placeholder="Add a custom note to the triage message"
            [(ngModel)]="step.data.action.data.note"
          >
          </ion-input>
        </div>

        <div style="margin-top: 10px">
          <ion-label class="input-label">Triage message template</ion-label>
          <br />

          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectTemplate(step.data.action.data)"
          >
            <ion-label>
              {{
                lookups?.["templateId"]?.[step.data.action.data.templateId] ??
                  "None"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-content>

      <!-- Add User to Google Group Section -->
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.ADD_USER_TO_GOOGLE_GROUP"
      >
        <!-- Google Group ID Input -->
        @if (authService.tenant.integrations?.google?.enabled) {
          <div>
            <ion-label class="input-label">Google Group ID</ion-label>
            <br />
            <ion-input
              class="input-field"
              placeholder="Enter Google Group ID (e.g., group@example.com)"
              [(ngModel)]="step.data.action.data.googleGroupId"
            ></ion-input>
          </div>

          <!-- User Source Selection -->
          <div style="margin-top: 10px">
            <ion-label class="input-label">User to add</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              (click)="
                selectResolvableEntity(
                  step.data.action.data,
                  'userId',
                  ENTITY_TYPES.USER
                )
              "
            >
              <ion-label>
                {{
                  step.data.action.data.userId
                    ? getResolvableEntityLabel(step.data.action.data.userId)
                    : "Select user field"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- Specific User Selection (Conditional) -->
          <div
            style="margin-top: 10px"
            *ngIf="isEmptyEntityType(step.data.action.data.userId)"
          >
            <ion-label class="input-label">Select specific user</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              (click)="
                selectSpecificEntity(
                  step.data.action.data,
                  'userId',
                  ENTITY_TYPES.USER
                )
              "
            >
              <ion-label>
                {{
                  lookups?.["assigneeId"]?.[
                    step.data.action.data.userId?.value ?? ""
                  ] ?? "Select user"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
        } @else {
          <ion-button color="dark" routerLink="/dashboard/admin/apps">
            <ion-icon name="information-circle" class="padded-icon"></ion-icon>
            Connect to Google
          </ion-button>
        }
      </ion-card-content>
      <!-- End Add User to Google Group Section -->

      <!-- Grant Okta Group Access Section -->
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.GRANT_OKTA_GROUP_ACCESS"
      >
        <!-- Integration Disabled Warning -->
        @if (!authService.tenant.integrations?.okta?.enabled) {
          <div
            class="integration-warning"
            style="
              margin-bottom: 15px;
              padding: 10px;
              background-color: #fff3cd;
              border: 1px solid #ffc107;
              border-radius: 4px;
            "
          >
            <div style="display: flex; align-items: center; margin-bottom: 8px">
              <ion-icon
                name="warning"
                color="warning"
                style="margin-right: 8px"
              ></ion-icon>
              <span style="color: #856404; font-weight: 500"
                >Okta Integration Disabled</span
              >
            </div>
            <p style="margin: 0 0 8px 0; color: #856404; font-size: 14px">
              This action will not execute until the Okta integration is enabled
              and configured.
            </p>
            <ion-button
              size="small"
              color="warning"
              routerLink="/dashboard/admin/apps"
            >
              <ion-icon name="settings" style="margin-right: 4px"></ion-icon>
              Configure Okta Integration
            </ion-button>
          </div>
        }

        <!-- Action Configuration (always visible) -->
        <div
          [style.opacity]="
            authService.tenant.integrations?.okta?.enabled ? '1' : '0.6'
          "
        >
          <div>
            <ion-label class="input-label">Okta Group</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectOktaGroup(step.data.action.data, $event)
              "
            >
              <ion-label>
                {{ getOktaGroupLabel(step.data.action.data.oktaGroupId) }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- User Source Selection -->
          <div style="margin-top: 10px">
            <ion-label class="input-label">User to grant access</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectResolvableEntity(
                    step.data.action.data,
                    'userId',
                    ENTITY_TYPES.USER
                  )
              "
            >
              <ion-label>
                {{
                  step.data.action.data.userId
                    ? getResolvableEntityLabel(step.data.action.data.userId)
                    : "Select user field"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- Specific User Selection (Conditional) -->
          <div
            style="margin-top: 10px"
            *ngIf="isEmptyEntityType(step.data.action.data.userId)"
          >
            <ion-label class="input-label">Select specific user</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectSpecificEntity(
                    step.data.action.data,
                    'userId',
                    ENTITY_TYPES.USER
                  )
              "
            >
              <ion-label>
                {{
                  lookups?.["assigneeId"]?.[
                    step.data.action.data.userId?.value ?? ""
                  ] ?? "Select user"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- Expires In (Optional) -->
          <div style="margin-top: 10px">
            <ion-label class="input-label">Expires in (optional)</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectOktaExpiry(step.data.action.data, $event)
              "
            >
              <ion-label>
                {{
                  step.data.action.data.expiresIn
                    ? getOktaExpiryLabel(
                        step.data.action.data.expiresIn,
                        step.data.action.data._uiState
                      )
                    : "Select duration or custom field"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>

            <!-- Custom Number Input (Conditional) -->
            <div
              style="margin-top: 10px"
              *ngIf="step.data.action.data._uiState?.showCustomExpiryInput"
            >
              <ion-input
                class="input-field"
                type="number"
                placeholder="Enter minutes (e.g., 60, 1440, 4320)"
                [value]="
                  step.data.action.data._uiState?.customExpiryValue || ''
                "
                (ionInput)="
                  onCustomExpiryNumberChange(step.data.action.data, $event)
                "
                [class.error]="
                  step.data.action.data._uiState?.hasCustomExpiryError
                "
                [disabled]="!authService.tenant.integrations?.okta?.enabled"
              ></ion-input>
              <ion-note
                *ngIf="step.data.action.data._uiState?.hasCustomExpiryError"
                color="danger"
                style="display: block; margin-top: 4px; font-size: 0.75rem"
              >
                Please enter a valid number greater than 0
              </ion-note>
            </div>
          </div>

          <!-- Specific Duration Selection (Conditional) -->
          <div
            style="margin-top: 10px"
            *ngIf="
              showSpecificEntitySelection(step.data.action.data, 'expiresIn')
            "
          >
            <ion-label class="input-label">Select duration</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectOktaExpiryDuration(step.data.action.data)
              "
            >
              <ion-label>
                {{
                  getOktaExpiryDurationLabel(
                    step.data.action.data.expiresIn?.value
                  ) ?? "Select duration"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
        </div>
      </ion-card-content>

      <!-- Revoke Okta Group Access Section -->
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.REVOKE_OKTA_GROUP_ACCESS"
      >
        <!-- Integration Disabled Warning -->
        @if (!authService.tenant.integrations?.okta?.enabled) {
          <div
            class="integration-warning"
            style="
              margin-bottom: 15px;
              padding: 10px;
              background-color: #fff3cd;
              border: 1px solid #ffc107;
              border-radius: 4px;
            "
          >
            <div style="display: flex; align-items: center; margin-bottom: 8px">
              <ion-icon
                name="warning"
                color="warning"
                style="margin-right: 8px"
              ></ion-icon>
              <span style="color: #856404; font-weight: 500"
                >Okta Integration Disabled</span
              >
            </div>
            <p style="margin: 0 0 8px 0; color: #856404; font-size: 14px">
              This action will not execute until the Okta integration is enabled
              and configured.
            </p>
            <ion-button
              size="small"
              color="warning"
              routerLink="/dashboard/admin/apps"
            >
              <ion-icon name="settings" style="margin-right: 4px"></ion-icon>
              Configure Okta Integration
            </ion-button>
          </div>
        }

        <!-- Action Configuration (always visible) -->
        <div
          [style.opacity]="
            authService.tenant.integrations?.okta?.enabled ? '1' : '0.6'
          "
        >
          <div>
            <ion-label class="input-label">Okta Group</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectOktaGroup(step.data.action.data, $event)
              "
            >
              <ion-label>
                {{ getOktaGroupLabel(step.data.action.data.oktaGroupId) }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- User Source Selection -->
          <div style="margin-top: 10px">
            <ion-label class="input-label"
              >User to revoke access from</ion-label
            >
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectResolvableEntity(
                    step.data.action.data,
                    'userId',
                    ENTITY_TYPES.USER
                  )
              "
            >
              <ion-label>
                {{
                  step.data.action.data.userId
                    ? getResolvableEntityLabel(step.data.action.data.userId)
                    : "Select user field"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- Specific User Selection (Conditional) -->
          <div
            style="margin-top: 10px"
            *ngIf="isEmptyEntityType(step.data.action.data.userId)"
          >
            <ion-label class="input-label">Select specific user</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectSpecificEntity(
                    step.data.action.data,
                    'userId',
                    ENTITY_TYPES.USER
                  )
              "
            >
              <ion-label>
                {{
                  lookups?.["assigneeId"]?.[
                    step.data.action.data.userId?.value ?? ""
                  ] ?? "Select user"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
        </div>
      </ion-card-content>

      <!-- Assign Okta Application Section -->
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.ASSIGN_OKTA_APPLICATION_ACCESS"
      >
        <!-- Integration Disabled Warning -->
        @if (!authService.tenant.integrations?.okta?.enabled) {
          <div
            class="integration-warning"
            style="
              margin-bottom: 15px;
              padding: 10px;
              background-color: #fff3cd;
              border: 1px solid #ffc107;
              border-radius: 4px;
            "
          >
            <div style="display: flex; align-items: center; margin-bottom: 8px">
              <ion-icon
                name="warning"
                color="warning"
                style="margin-right: 8px"
              ></ion-icon>
              <span style="color: #856404; font-weight: 500"
                >Okta Integration Disabled</span
              >
            </div>
            <p style="margin: 0 0 8px 0; color: #856404; font-size: 14px">
              This action will not execute until the Okta integration is enabled
              and configured.
            </p>
            <ion-button
              size="small"
              color="warning"
              routerLink="/dashboard/admin/apps"
            >
              <ion-icon name="settings" style="margin-right: 4px"></ion-icon>
              Configure Okta Integration
            </ion-button>
          </div>
        }

        <!-- Action Configuration (always visible) -->
        <div
          [style.opacity]="
            authService.tenant.integrations?.okta?.enabled ? '1' : '0.6'
          "
        >
          <div>
            <ion-label class="input-label">Okta Application</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectOktaApplication(step.data.action.data, $event)
              "
            >
              <ion-label>
                {{
                  getOktaApplicationLabel(
                    step.data.action.data.oktaApplicationId
                  )
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- User Source Selection -->
          <div style="margin-top: 10px">
            <ion-label class="input-label"
              >User to assign application</ion-label
            >
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectResolvableEntity(
                    step.data.action.data,
                    'userId',
                    ENTITY_TYPES.USER
                  )
              "
            >
              <ion-label>
                {{
                  step.data.action.data.userId
                    ? getResolvableEntityLabel(step.data.action.data.userId)
                    : "Select user field"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- Specific User Selection (Conditional) -->
          <div
            style="margin-top: 10px"
            *ngIf="isEmptyEntityType(step.data.action.data.userId)"
          >
            <ion-label class="input-label">Select specific user</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectSpecificEntity(
                    step.data.action.data,
                    'userId',
                    ENTITY_TYPES.USER
                  )
              "
            >
              <ion-label>
                {{
                  lookups?.["assigneeId"]?.[
                    step.data.action.data.userId?.value ?? ""
                  ] ?? "Select user"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- Expires In (Optional) -->
          <div style="margin-top: 10px">
            <ion-label class="input-label">Expires in (optional)</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectOktaExpiry(step.data.action.data, $event)
              "
            >
              <ion-label>
                {{
                  step.data.action.data.expiresIn
                    ? getOktaExpiryLabel(
                        step.data.action.data.expiresIn,
                        step.data.action.data._uiState
                      )
                    : "Select duration or custom field"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>

            <!-- Custom Number Input (Conditional) -->
            <div
              style="margin-top: 10px"
              *ngIf="step.data.action.data._uiState?.showCustomExpiryInput"
            >
              <ion-input
                class="input-field"
                type="number"
                placeholder="Enter minutes (e.g., 60, 1440, 4320)"
                [value]="
                  step.data.action.data._uiState?.customExpiryValue || ''
                "
                (ionInput)="
                  onCustomExpiryNumberChange(step.data.action.data, $event)
                "
                [class.error]="
                  step.data.action.data._uiState?.hasCustomExpiryError
                "
                [disabled]="!authService.tenant.integrations?.okta?.enabled"
              ></ion-input>
              <ion-note
                *ngIf="step.data.action.data._uiState?.hasCustomExpiryError"
                color="danger"
                style="display: block; margin-top: 4px; font-size: 0.75rem"
              >
                Please enter a valid number greater than 0
              </ion-note>
            </div>
          </div>

          <!-- Specific Duration Selection (Conditional) -->
          <div
            style="margin-top: 10px"
            *ngIf="
              showSpecificEntitySelection(step.data.action.data, 'expiresIn')
            "
          >
            <ion-label class="input-label">Select duration</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectOktaExpiryDuration(step.data.action.data)
              "
            >
              <ion-label>
                {{
                  getOktaExpiryDurationLabel(
                    step.data.action.data.expiresIn?.value
                  ) ?? "Select duration"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
        </div>
      </ion-card-content>

      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.SET_CUSTOM_FIELD"
      >
        <div>
          <ion-label class="input-label"> Set </ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectCustomField(step.data.action.data, $event)"
          >
            <ion-label>
              {{ selectedCustomFieldForAction?.label ?? "Select custom field" }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>

          <!-- Choose how to set the value -->
          <div style="margin-top: 10px">
            <ion-label class="input-label">To</ion-label>
            <br />

            <!-- Show resolvable entity selector by default -->
            <div
              *ngIf="
                !showSpecificEntitySelection(step.data.action.data, 'value')
              "
            >
              <ion-chip
                mode="ios"
                class="select-chip select-outline no-margin"
                [outline]="true"
                (click)="
                  selectResolvableEntity(
                    step.data.action.data,
                    'value',
                    selectedCustomFieldForAction?.type
                  )
                "
                [disabled]="!selectedCustomFieldForAction"
              >
                <ion-label>
                  {{
                    step.data.action.data.value
                      ? getResolvableEntityLabel(
                          step.data.action.data.value,
                          selectedCustomFieldForAction?.type
                        )
                      : "Select or enter value"
                  }}
                  <ion-icon
                    name="caret-down-outline"
                    class="icon-padded-left"
                  ></ion-icon>
                </ion-label>
              </ion-chip>
            </div>

            <!-- Show specific value input when user selects "Specific Value" -->
            <div
              *ngIf="
                showSpecificEntitySelection(step.data.action.data, 'value')
              "
            >
              <!-- For user/user-group types, show entity selector -->
              <div
                *ngIf="
                  selectedCustomFieldForAction?.type === 'user-select' ||
                  selectedCustomFieldForAction?.type === 'user-group-select'
                "
              >
                <ion-chip
                  mode="ios"
                  class="select-chip select-outline no-margin"
                  [outline]="true"
                  (click)="
                    selectSpecificEntity(
                      step.data.action.data,
                      'value',
                      selectedCustomFieldForAction?.type
                    )
                  "
                >
                  <ion-label>
                    {{
                      getValueForDisplayLookup(
                        step.data.action.data.value,
                        selectedCustomFieldForAction?.type
                      ) ??
                        "Select " +
                          (selectedCustomFieldForAction?.type === "user-select"
                            ? "user"
                            : "user group")
                    }}
                    <ion-icon
                      name="caret-down-outline"
                      class="icon-padded-left"
                    ></ion-icon>
                  </ion-label>
                </ion-chip>
                <!-- Button to go back to resolvable selector -->
                <ion-button
                  fill="clear"
                  color="medium"
                  class="no-margin"
                  (click)="step.data.action.data.value = null"
                >
                  Clear
                </ion-button>
              </div>

              <!-- For other field types, show standard input component -->
              <div
                *ngIf="
                  selectedCustomFieldForAction?.type !== 'user-select' &&
                  selectedCustomFieldForAction?.type !== 'user-group-select'
                "
              >
                <app-automation-custom-field-input
                  [customField]="selectedCustomFieldForAction"
                  [value]="hydratedCustomFieldValue"
                  (valueChange)="onCustomFieldValueChange($event)"
                  [projectId]="projectId"
                >
                </app-automation-custom-field-input>
              </div>
            </div>
          </div>
        </div>
      </ion-card-content>

      <!-- Revoke Okta Application Access Section -->
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.REVOKE_OKTA_APPLICATION_ACCESS"
      >
        <!-- Integration Disabled Warning -->
        @if (!authService.tenant.integrations?.okta?.enabled) {
          <div
            class="integration-warning"
            style="
              margin-bottom: 15px;
              padding: 10px;
              background-color: #fff3cd;
              border: 1px solid #ffc107;
              border-radius: 4px;
            "
          >
            <div style="display: flex; align-items: center; margin-bottom: 8px">
              <ion-icon
                name="warning"
                color="warning"
                style="margin-right: 8px"
              ></ion-icon>
              <span style="color: #856404; font-weight: 500"
                >Okta Integration Disabled</span
              >
            </div>
            <p style="margin: 0 0 8px 0; color: #856404; font-size: 14px">
              This action will not execute until the Okta integration is enabled
              and configured.
            </p>
            <ion-button
              size="small"
              color="warning"
              routerLink="/dashboard/admin/apps"
            >
              <ion-icon name="settings" style="margin-right: 4px"></ion-icon>
              Configure Okta Integration
            </ion-button>
          </div>
        }

        <!-- Action Configuration (always visible) -->
        <div
          [style.opacity]="
            authService.tenant.integrations?.okta?.enabled ? '1' : '0.6'
          "
        >
          <div>
            <ion-label class="input-label">Okta Application</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectOktaApplication(step.data.action.data, $event)
              "
            >
              <ion-label>
                {{
                  getOktaApplicationLabel(
                    step.data.action.data.oktaApplicationId
                  )
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- User Source Selection -->
          <div style="margin-top: 10px">
            <ion-label class="input-label"
              >User to revoke access from</ion-label
            >
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectResolvableEntity(
                    step.data.action.data,
                    'userId',
                    ENTITY_TYPES.USER
                  )
              "
            >
              <ion-label>
                {{
                  step.data.action.data.userId
                    ? getResolvableEntityLabel(step.data.action.data.userId)
                    : "Select user field"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- Specific User Selection (Conditional) -->
          <div
            style="margin-top: 10px"
            *ngIf="isEmptyEntityType(step.data.action.data.userId)"
          >
            <ion-label class="input-label">Select specific user</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              [disabled]="!authService.tenant.integrations?.okta?.enabled"
              (click)="
                authService.tenant.integrations?.okta?.enabled &&
                  selectSpecificEntity(
                    step.data.action.data,
                    'userId',
                    ENTITY_TYPES.USER
                  )
              "
            >
              <ion-label>
                {{
                  lookups?.["assigneeId"]?.[
                    step.data.action.data.userId?.value ?? ""
                  ] ?? "Select user"
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
        </div>
      </ion-card-content>

      <!-- Add Reaction Emoji Section -->
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.ADD_REACTION_EMOJI"
      >
        <div>
          <ion-label class="input-label">Emoji to add:</ion-label>
          <br />

          <!-- Static emoji input -->
          <div class="flexed-align-center">
            <ion-button
              color="light"
              (click)="openEmojiPicker($event)"
              style="--padding-top: 12px; --padding-bottom: 12px; height: auto"
            >
              <ng-container *ngIf="hydratedEmojiValue">
                <span
                  *ngIf="isHTML(hydratedEmojiValue)"
                  [innerHTML]="hydratedEmojiValue"
                  class="action-icon"
                  style="width: 1.8rem"
                ></span>
                <span
                  *ngIf="!isHTML(hydratedEmojiValue)"
                  style="font-size: 1.8rem"
                  >{{ hydratedEmojiValue }}</span
                >
              </ng-container>
              <span *ngIf="!hydratedEmojiValue">Choose emoji</span>
            </ion-button>
          </div>
        </div>
      </ion-card-content>
      <!-- End Add Reaction Emoji Section -->

      <!-- Create Jira Task Section -->
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.CREATE_JIRA_TASK"
      >
        <!-- Jira Integration Check -->
        <div
          *ngIf="!authService.tenant.integrations?.jira?.enabled"
          style="margin-bottom: 15px"
        >
          <ion-note color="warning" style="display: block; margin-bottom: 10px">
            <ion-icon name="warning-outline"></ion-icon>
            Jira integration is not configured. Please configure Jira
            integration in Admin > Apps first.
          </ion-note>
          <ion-button
            color="dark"
            routerLink="/dashboard/admin/apps"
            size="small"
          >
            <ion-icon name="settings-outline" class="padded-icon"></ion-icon>
            Configure Jira
          </ion-button>
        </div>

        <!-- Project Key -->
        <div>
          <ion-label class="input-label">Project Key</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectJiraProject(step.data.action.data)"
          >
            <ion-label>
              {{ step.data.action?.data?.projectKey || "Select project key" }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <!-- Issue Type -->
        <div style="margin-top: 10px">
          <div class="flexed-align-center">
            <ion-label class="input-label">Issue Type</ion-label>
            <ion-icon
              name="information-circle"
              style="
                margin-left: 5px;
                color: var(--ion-color-medium);
                cursor: help;
              "
              ngxTippy
              data-tippy-content="Common Issue Types: Bug, Task, Story"
            ></ion-icon>
          </div>
          <ion-input
            class="input-field"
            placeholder="Enter issue type name (e.g., Task)"
            [(ngModel)]="step.data.action.data.issueType"
          ></ion-input>
        </div>

        <!-- Priority Mapping Section -->
        <div
          style="
            margin-top: 15px;
            padding-top: 10px;
            border-top: 1px solid var(--ion-border-color);
          "
        >
          <ion-label class="input-label">Priority Mapping</ion-label>
          <ion-note class="input-label" style="display: block; margin-top: 8px">
            Map conversation priorities to Jira priority field values. If not
            mapped, no priority will be set in Jira.
          </ion-note>
          <div
            *ngFor="let priorityOption of priorityOptionsForTemplate"
            style="margin-bottom: 10px"
          >
            <div class="flexed-align-center">
              <ion-label
                class="input-label"
                style="min-width: 80px; margin-right: 10px"
              >
                {{ priorityOption.label }}
              </ion-label>
              <ion-input
                class="input-field"
                [placeholder]="
                  'Enter Jira priority for ' +
                  priorityOption.label.toLowerCase()
                "
                [(ngModel)]="
                  step.data.action.data.priorityMapping[priorityOption.value]
                "
                style="flex: 1"
              ></ion-input>
            </div>
          </div>
        </div>
      </ion-card-content>
      <!-- End Create Jira Task Section -->

      <!-- Create Conversation Section -->
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.CREATE_CONVERSATION"
      >
        <!-- Header with Pills -->
        <div style="margin-bottom: 15px">
          <div class="input-container">
            <span class="input-label">Status</span>
            <ion-button
              fill="clear"
              color="dark"
              (click)="selectConversationStatus(step.data.action.data)"
              class="btn-xs button-dark-border"
            >
              <!-- Merge field icon -->
              <ion-icon
                *ngIf="
                  getConversationStatusValue(step.data.action.data.status) ===
                  'conversation.status'
                "
                name="flash-outline"
                class="button-icon"
                style="margin-right: 5px"
              ></ion-icon>
              <!-- Static status icons -->
              <ion-icon
                *ngIf="
                  getConversationStatusValue(step.data.action.data.status) ===
                  'open'
                "
                name="custom-open"
                class="status-label-needs-response button-icon"
                style="margin-right: 5px"
              ></ion-icon>
              <ion-icon
                *ngIf="
                  getConversationStatusValue(step.data.action.data.status) ===
                  'in_progress'
                "
                name="custom-in-progress"
                class="status-label-in-progress button-icon"
                style="margin-right: 5px"
              ></ion-icon>
              <ion-icon
                *ngIf="
                  getConversationStatusValue(step.data.action.data.status) ===
                  'on_hold'
                "
                name="custom-on-hold"
                class="status-label-on-hold button-icon"
                style="margin-right: 5px"
              ></ion-icon>
              <ion-icon
                *ngIf="
                  getConversationStatusValue(step.data.action.data.status) ===
                  'closed'
                "
                name="custom-closed"
                class="status-label-closed button-icon"
                style="margin-right: 5px"
              ></ion-icon>
              {{ getConversationStatusLabel(step.data.action.data.status) }}
            </ion-button>
          </div>
          <div class="input-container">
            <span class="input-label">Priority</span>
            <ion-button
              fill="clear"
              color="dark"
              (click)="selectConversationPriority(step.data.action.data)"
              class="btn-xs button-dark-border"
            >
              <img
                *ngIf="
                  getConversationPriorityIcon(step.data.action.data.priority) &&
                  isURL(
                    getConversationPriorityIcon(step.data.action.data.priority)
                      | colonToEmoji
                  )
                "
                [src]="
                  getConversationPriorityIcon(step.data.action.data.priority)
                    | colonToEmoji
                "
                alt="Emoji"
                style="width: 1em; margin-right: 5px"
              />
              <span
                *ngIf="
                  getConversationPriorityIcon(step.data.action.data.priority) &&
                  !isURL(
                    getConversationPriorityIcon(step.data.action.data.priority)
                      | colonToEmoji
                  )
                "
                style="margin-right: 5px"
              >
                {{
                  getConversationPriorityIcon(step.data.action.data.priority)
                    | colonToEmoji
                }}
              </span>
              {{ getConversationPriorityLabel(step.data.action.data.priority) }}
            </ion-button>
          </div>

          <div class="input-container">
            <span class="input-label">Project</span>
            <ion-button
              fill="clear"
              color="dark"
              (click)="selectConversationProject(step.data.action.data)"
              class="btn-xs button-dark-border"
            >
              {{
                getConversationProjectLabel(step.data.action.data.projectId) ||
                  "Project"
              }}
            </ion-button>
          </div>
        </div>

        <!-- Title (Optional) -->
        <div style="margin-bottom: 10px">
          <ion-label class="input-label">Title</ion-label>
          <div
            style="
              border-radius: 8px;
              border: 1px solid var(--ion-border-color);
              margin-top: 4px;
            "
          >
            <app-slack-text-editor
              [content]="step.data.action.data.title?.value || ''"
              [isRichText]="false"
              placeholder="e.g. Customer issue with login"
              (contentDidChange)="onTitleChange(step.data.action.data, $event)"
              [projectId]="projectId ?? undefined"
            ></app-slack-text-editor>
          </div>
        </div>

        <!-- Issue Details -->
        <div style="margin-bottom: 10px">
          <ion-label class="input-label">Issue details</ion-label>
          <div
            style="
              border-radius: 8px;
              border: 1px solid var(--ion-border-color);
              margin-top: 4px;
            "
          >
            <app-slack-text-editor
              [content]="step.data.action.data.description?.value || ''"
              [isRichText]="false"
              placeholder="e.g. Customer needs help resetting password"
              (contentDidChange)="
                onIssueDetailsChange(step.data.action.data, $event)
              "
              [projectId]="projectId ?? undefined"
            ></app-slack-text-editor>
          </div>
        </div>

        <!-- Submitter and Post to -->
        <div class="flexed" style="margin-top: 10px">
          <div style="width: 50%">
            <ion-label class="input-label">Submitter</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline"
              [outline]="true"
              (click)="selectConversationSubmitter(step.data.action.data)"
              style="width: 100%; margin-left: -1px"
            >
              <ion-label class="wide-chip-dropdown-label">
                <span>{{
                  getConversationSubmitterLabel(
                    step.data.action.data.submitterId
                  ) || "None"
                }}</span>
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
          <div style="width: 50%; margin-left: 8px">
            <ion-label class="input-label">Post to</ion-label>
            <div class="flexed" style="margin-top: 4px">
              <div
                class="round-pill-tab round-pill-tab-left"
                [ngClass]="{
                  'round-pill-tab-active':
                    getConversationPostingType(step.data.action.data) ===
                    'channel'
                }"
                (click)="
                  setConversationPostingType(step.data.action.data, 'channel')
                "
              >
                Channel
              </div>
              <div
                class="round-pill-tab round-pill-tab-right"
                [ngClass]="{
                  'round-pill-tab-active':
                    getConversationPostingType(step.data.action.data) ===
                    'direct'
                }"
                (click)="
                  setConversationPostingType(step.data.action.data, 'direct')
                "
              >
                Direct Message
              </div>
            </div>
          </div>
        </div>

        <!-- Direct Message: Send to User and Send as -->
        <div
          class="flexed"
          style="margin-top: 10px"
          *ngIf="getConversationPostingType(step.data.action.data) === 'direct'"
        >
          <div style="width: 50%">
            <ion-label class="input-label"
              >Send to User
              <ion-text color="warning">(Required)</ion-text></ion-label
            >
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline"
              [outline]="true"
              (click)="
                selectConversationDirectMessageUser(step.data.action.data)
              "
              style="width: 100%; margin-left: -1px"
            >
              <ion-label class="wide-chip-dropdown-label">
                <span>{{
                  getConversationDirectMessageUserLabel(
                    step.data.action.data.entityId
                  ) || "Select User"
                }}</span>
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
          <div style="width: 50%; margin-left: 8px">
            <ion-label class="input-label">Send as</ion-label>
            <br />
            <ion-select
              mode="ios"
              class="input-field select-outline"
              interface="popover"
              placeholder="Select user"
              aria-label="Send as"
              [(ngModel)]="step.data.action.data.sendAs"
              (ngModelChange)="
                onConversationSendAsChange(step.data.action.data, $event)
              "
              style="
                padding-right: 13px;
                padding-top: 6px;
                padding-bottom: 6px;
                padding-left: 1px;
                font-size: 0.75rem;
                margin-top: 4px;
                padding-left: 11px;
              "
            >
              <ion-select-option value="support_team"
                >Support Team (default)</ion-select-option
              >
              <ion-select-option value="ticket_assignee"
                >Ticket Assignee</ion-select-option
              >
            </ion-select>
          </div>
        </div>

        <!-- Link Type and Channel Selector Row -->
        <div
          class="flexed"
          style="margin-top: 10px"
          *ngIf="
            shouldShowConversationLinks() ||
            getConversationPostingType(step.data.action.data) === 'channel'
          "
        >
          <!-- Link Type (only for button click and event triggers) -->
          <div style="width: 50%" *ngIf="shouldShowConversationLinks()">
            <ion-label class="input-label">Link Type</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline"
              [outline]="true"
              (click)="selectConversationLinkType(step.data.action.data)"
              style="width: 100%; margin-left: -1px"
            >
              <ion-label class="wide-chip-dropdown-label">
                <span>{{
                  getSelectedConversationLinkTypeLabel(step.data.action.data) ||
                    "None"
                }}</span>
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- Channel Selector (when posting to channel) -->
          <div
            [style.width]="shouldShowConversationLinks() ? '50%' : '100%'"
            [style.margin-left]="shouldShowConversationLinks() ? '8px' : '0'"
            *ngIf="
              getConversationPostingType(step.data.action.data) === 'channel'
            "
          >
            <ion-label class="input-label"
              >Channel
              <ion-text color="warning">(Required)</ion-text></ion-label
            >
            <br />
            <app-channel-selector
              [channel]="getConversationChannel(step.data.action.data)"
              (channelDidChange)="
                onConversationChannelChanged(step.data.action.data, $event)
              "
              [defaultInternalOnly]="true"
              [initialButtonText]="'Select Channel'"
              [maxDisplayTextLength]="22"
              [showConfirmationModal]="false"
              style="width: 100%; margin-top: 4px"
            ></app-channel-selector>
          </div>
        </div>

        <!-- Ticket Type -->
        <div
          style="
            margin-top: 15px;
            padding-top: 10px;
            border-top: 1px solid var(--ion-border-color);
          "
        >
          <ion-label class="input-label">Ticket Type</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            (click)="selectConversationTicketType(step.data.action.data)"
            style="width: 100%; margin-left: -1px"
          >
            <ion-label class="wide-chip-dropdown-label">
              <span>{{
                getConversationTicketTypeLabel(
                  step.data.action.data.ticketTypeId
                ) || "None"
              }}</span>
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>
        <div
          style="
            margin-top: 10px;
            border: 1px solid var(--ion-border-color);
            border-radius: 8px;
          "
          *ngIf="
            getConversationRenderableFieldDefinitions(
              step.data.action.data.ticketTypeId
            )?.length
          "
        >
          <!-- Custom Fields Component -->
          <app-ticket-type-fields
            [fieldDefinitions]="
              getConversationRenderableFieldDefinitions(
                step.data.action.data.ticketTypeId
              )
            "
            [fieldValues]="step.data.action.data.customFieldValues || {}"
            (fieldValuesChange)="
              onConversationFieldValuesChange(step.data.action.data, $event)
            "
            [customerId]="step.data.action.data.customerId"
            [projectId]="step.data.action.data.projectId"
            [ticketTypeId]="step.data.action.data.ticketTypeId"
            [disabled]="false"
          ></app-ticket-type-fields>
        </div>
      </ion-card-content>
      <!-- End Create Conversation Section -->

      <!-- Generate AI Message Section -->
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.GENERATE_AI_MESSAGE"
      >
        <ion-note
          class="input-label"
          style="display: block; margin-top: 0; margin-bottom: 15px"
        >
          This step will generate an autoresponder message for the conversation,
          which can be used as a variable in later steps.
        </ion-note>
        <div>
          <ion-label class="input-label"
            >Additional instructions (optional)</ion-label
          >
          <br />
          <ion-input
            class="input-field"
            placeholder="Add additional context or instructions for the AI generation..."
            [(ngModel)]="step.data.action.data.additionalInstructions"
          >
          </ion-input>
        </div>
      </ion-card-content>
      <!-- End Generate AI Message Section -->

      <!-- Create Escalation Section -->
      <ion-card-content
        *ngSwitchCase="AUTOMATION_ACTION_TYPES.CREATE_ESCALATION"
      >
        <!-- Escalation Type -->
        <div style="margin-bottom: 10px">
          <ion-label class="input-label"
            >Escalation Type
            <ion-text color="warning">(Required)</ion-text></ion-label
          >
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            (click)="selectEscalationType(step.data.action.data, $event)"
            style="width: 100%; margin-left: -1px"
          >
            <ion-label class="wide-chip-dropdown-label">
              <span>{{
                lookups?.["escalationTypeId"]?.[
                  step.data.action.data.escalationTypeId
                ] || "Select Escalation Type"
              }}</span>
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <!-- Assignee -->
        <div *ngIf="showAssigneeField" style="margin-bottom: 10px">
          <ion-label class="input-label"
            >Assignee
            <ion-text *ngIf="isAssigneeRequired" color="warning"
              >(Required)</ion-text
            >
          </ion-label>
          <br />
          <ion-button
            fill="clear"
            color="dark"
            (click)="selectEscalationAssignee(step.data.action.data, $event)"
            class="btn-xs button-dark-border"
          >
            {{ getEscalationAssigneeLabel(step.data.action.data) || "No one" }}
          </ion-button>
        </div>

        <!-- Priority -->
        <div *ngIf="showPriorityField" style="margin-bottom: 10px">
          <ion-label class="input-label"
            >Priority
            <ion-text *ngIf="isPriorityRequired" color="warning"
              >(Required)</ion-text
            >
          </ion-label>
          <br />
          <ion-button
            fill="clear"
            color="dark"
            (click)="selectEscalationPriority(step.data.action.data)"
            class="btn-xs button-dark-border"
          >
            {{
              getEscalationPriorityLabel(step.data.action.data.priority) ||
                "Priority"
            }}
          </ion-button>
        </div>
        <!-- Subject -->
        <div style="margin-bottom: 10px">
          <ion-label class="input-label"
            >Subject <ion-text color="warning">(Required)</ion-text></ion-label
          >
          <div
            style="
              border-radius: 8px;
              border: 1px solid var(--ion-border-color);
              margin-top: 4px;
            "
          >
            <app-slack-text-editor
              [content]="step.data.action.data.title?.value || ''"
              [isRichText]="false"
              placeholder="e.g. Customer issue requires escalation"
              (contentDidChange)="
                onEscalationTitleChange(step.data.action.data, $event)
              "
              [projectId]="projectId ?? undefined"
            ></app-slack-text-editor>
          </div>
        </div>

        <!-- Additional Details -->
        <div style="margin-bottom: 10px">
          <ion-label class="input-label">Additional details</ion-label>
          <div
            style="
              border-radius: 8px;
              border: 1px solid var(--ion-border-color);
              margin-top: 4px;
            "
          >
            <app-slack-text-editor
              [content]="step.data.action.data.body || ''"
              [isRichText]="false"
              placeholder="e.g. Additional context about the escalation"
              (contentDidChange)="
                onEscalationAdditionalDetailsChange(
                  step.data.action.data,
                  $event
                )
              "
              [projectId]="projectId ?? undefined"
            ></app-slack-text-editor>
          </div>
        </div>

        <!-- Public Note -->
        <div style="margin-bottom: 10px">
          <ion-label class="input-label">Public note</ion-label>
          <div
            style="
              border-radius: 8px;
              border: 1px solid var(--ion-border-color);
              margin-top: 4px;
            "
          >
            <app-slack-text-editor
              [content]="step.data.action.data.publicNote || ''"
              [isRichText]="false"
              placeholder="e.g. Note to include in customer message"
              (contentDidChange)="
                onEscalationPublicNoteChange(step.data.action.data, $event)
              "
              [projectId]="projectId ?? undefined"
            ></app-slack-text-editor>
          </div>
        </div>

        <!-- Created By -->
        <div style="margin-bottom: 10px">
          <ion-label class="input-label">Created by</ion-label>
          <br />
          <ion-button
            fill="clear"
            color="dark"
            (click)="selectEscalationCreatedBy(step.data.action.data, $event)"
            class="btn-xs button-dark-border"
          >
            {{
              getEscalationCreatedByLabel(step.data.action.data.createdBy) ||
                "Select user"
            }}
          </ion-button>
        </div>
      </ion-card-content>
      <!-- End Create Escalation Section -->
    </ng-container>
  </ng-container>
</ion-card>
